function openModalMaterialDialog() {
    $('#modal-material-selector-dialog').modal('show');
    // toggle the buttons
}

function toggleMaterialButtons(button) {
    document.getElementById('steel-material-tab').classList.remove('btn-primary')
    document.getElementById('steel-material-tab').classList.add('btn-default')
    document.getElementById('european-steel-material-tab').classList.remove('btn-primary')
    document.getElementById('european-steel-material-tab').classList.add('btn-default')
    document.getElementById('astm-steel-material-tab').classList.remove('btn-primary')
    document.getElementById('astm-steel-material-tab').classList.add('btn-default')
    document.getElementById('wood-material-tab').classList.remove('btn-primary')
    document.getElementById('wood-material-tab').classList.add('btn-default')
    document.getElementById('aluminum-material-tab').classList.remove('btn-primary')
    document.getElementById('aluminum-material-tab').classList.add('btn-default')
    if(button) {
        button.classList.add('btn-primary')
    }
}

function initSteelTable() {
    const materials = steelMaterialJson

    let str = "<table class='table'><thead>"
    str += '<tr><th>Name</th><th>Fy (ksi)</th><th>Elastic Modulus (ksi)</th>'
    str += '</thead>'

    for( let m in materials ) {
        str += `<tr><td>${materials[m].Name}</td><td>${materials[m].Fy}</td><td>${materials[m].E}</td></tr>`
    }
    str += '</table>'

    let table = document.getElementById('steel-material-table')
    table.innerHTML = str

    var rows = table.getElementsByTagName("tr")
    for (let i = 1; i < rows.length; i++) {
        var currentRow = rows[i]
        currentRow.onclick = function() {
            $('#modal-material-selector-dialog').trigger( 'north-american-steel-material-selected', materials[i-1])
            $('#modal-material-selector-dialog').modal('toggle')
        }
    }
}

function initEuropeanSteelTable() {
    var materials = europeanSteelMaterialJson

    var str = "<table class='table'><thead>"
    str += '<tr><th>Name</th><th>Fy (MPa)</th><th>Elastic Modulus (GPa)</th>'
    str += '</thead>'

    for( var m in materials ) {
        str += `<tr><td>${materials[m].Name}</td><td>${materials[m].Fy}</td><td>${materials[m].E}</td></tr>`
    }
    str += '</table>'

    let table = document.getElementById('european-steel-material-table')
    table.innerHTML = str

    var rows = table.getElementsByTagName("tr")
    for (let i = 1; i < rows.length; i++) {
        var currentRow = rows[i];
        currentRow.onclick = function() {
            $('#modal-material-selector-dialog').trigger( 'european-steel-material-selected', materials[i-1]);
            $('#modal-material-selector-dialog').modal('toggle');
        }
    }
}

function initASTMSteelTable() {
    var materials = astmSteelMaterialJson;

    var str = "<table class='table'><thead>"
    str += '<tr><th>Name</th><th>Fy (MPa)</th><th>Elastic Modulus (GPa)</th>'
    str += '</thead>'

    for( var m in materials ) {
        str += `<tr><td>${materials[m].Name}</td><td>${materials[m].Fy}</td><td>${materials[m].E}</td></tr>`
    }
    str += '</table>'

    let table = document.getElementById('astm-steel-material-table')
    table.innerHTML = str

    var rows = table.getElementsByTagName("tr");
    for (let i = 1; i < rows.length; i++) {
        var currentRow = rows[i]
        currentRow.onclick = function() {
            $('#modal-material-selector-dialog').trigger( 'astm-steel-material-selected', materials[i-1])
            $('#modal-material-selector-dialog').modal('toggle')
        }
    }
}

function initAluminumTable() {
    var materials = aluminumMaterialJson;

    var str = "<table class='table'><thead>"
    str += '<tr><th>Name</th><th>Fy (ksi)</th><th>Elastic Modulus (ksi)</th>'
    str += '</thead>'

    for( var m in materials ) {
        str += `<tr><td>${materials[m].Name}</td><td>${materials[m].Fy}</td><td>${materials[m].E}</td></tr>`
    }
    str += '</table>'

    let table = document.getElementById('aluminum-material-table')
    table.innerHTML = str

    var rows = table.getElementsByTagName("tr")
    for (let i = 1; i < rows.length; i++) {
        var currentRow = rows[i]
        currentRow.onclick = function() {
            $('#modal-material-selector-dialog').trigger( 'aluminum-material-selected', materials[i-1])
            $('#modal-material-selector-dialog').modal('toggle')
        }
    }
}

function onWoodMaterialSelected(woodMaterial) {
    var str = "<table class='table wood-material-box wood-material-table'><thead>";
    str += "<tr class='no-border'>";
    str += '<th>' + woodMaterial['Species'] + '</th><th>Fb</th><th>Ft</th><th>Fv</th><th>Fc</th><th>E</th>';
    str += '</thead></tr>';
    str += "<tr class='no-border'>";
    str += '<td>' + woodMaterial['Grade'] + '</td>';
    str += '<td>' + woodMaterial['Fb'] + '</td>';
    str += '<td>' + woodMaterial['Ft'] + '</td>';
    str += '<td>' + woodMaterial['Fv'] + '</td>';
    str += '<td>' + woodMaterial['Fc'] + '</td>';
    str += '<td>' + woodMaterial['E'] + '</td></tr>';
    str += '</table>';
    document.getElementById('wood-material-heading').innerHTML = str
    //$('#wood-material-heading').html(str);
}
